import styled from 'styled-components'
import { Container } from 'reactstrap'

const PageContainer = styled(Container)`
  margin: 2rem auto;
`

export default PageContainer